import { ArticleReadScope } from '@tabeeb/contracts/microservices/swagger-article-service'

export const ArticleReadScopeDisplayName = {
  [ArticleReadScope.System]: 'System',
  [ArticleReadScope.Content]: 'Content',
}

export { ArticleReadScope }
